module.exports = "/static/assets/0f8250c86da66d5e91b16c369c3cd92b.svg";